import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchUser'
})
export class SearchUserPipe implements PipeTransform {

  transform(users: any[], text: string): any[] {
    let result = [];

    users.map(user => {
      if (user.name.toLowerCase().includes(text.toLowerCase()) || 
          user.surname.toLowerCase().includes(text.toLowerCase()) || 
          user.email.toLowerCase().includes(text.toLowerCase())) {
        result.push(user);
      }else{
        if (user.payments.length > 0){
          if (user.payments[user.payments.length - 1].description.toLowerCase().includes(text.toLowerCase())) {
            result.push(user);
          }
        }

      }
    })

    return result;
  }

}
